import styles from './sharePostPreview.module.less';
import { useSelector } from 'react-redux';
import { getProjectFromId } from '../projects-reducer';
import { SmallText, StrongText } from '@sb1/ffe-core-react';
import classNames from 'classnames';
import Spinner from '../../components/spinner/Spinner';
import useImgOnLoad from '../../components/hooks/useImgOnLoad';

const SharePostPreview = ({ projectId, className }) => {
    const [ref, loaded, onLoad] = useImgOnLoad();
    const project = useSelector((state) => getProjectFromId(state, projectId, true));
    const transactionForGiverInfo = useSelector((state) => state.transactions.transactionForGiverInfo);
    const subprojectId = transactionForGiverInfo?.subproject_id;
    const projectImageUrl = project.images?.img_urls?.cropped500 ?? project.img_url;

    return (
        <div className={[styles.container, className || ''].join(' ')}>
            {subprojectId ? (
                <>
                    {!loaded && <Spinner />}
                    <img
                        className={classNames(styles.previewPhoto, styles.imageShare)}
                        src={`/api/public/project/${projectId}/subproject/${subprojectId}/shareImage`}
                        title={'Last ned og del'}
                        alt={'Delingsbilde'}
                        ref={ref}
                        onLoad={onLoad}
                    />
                </>
            ) : (
                <div className={styles.imageWrapper}>
                    <div
                        style={{
                            backgroundImage: `url(${
                                projectImageUrl
                                    ? projectImageUrl
                                    : 'https://static.spleis.no/images/default-spleis-image.svg'
                            })`,
                        }}
                        className={styles.projectImage}
                    />
                </div>
            )}
            <div className={styles.textContainer}>
                <SmallText className={styles.link}>spleis.no</SmallText>
                <StrongText className={styles.title}>{project.title}</StrongText>
            </div>
        </div>
    );
};

export default SharePostPreview;
